export const VerificationErrorTypeEnum = {
	BAD_REQUEST: "badRequest",
	SELECTED_METHOD_EXHAUSTED: "selectedMethodExhausted",
	ALL_METHODS_EXHAUSTED: "allMethodsExhausted",
	TECHNICAL_ERROR: "technicalError",
	ALREADY_DECLINED: "alreadyDeclined",
	ALREADY_ACCEPTED: "alreadyAccepted",
	DENIED_BY_USER: "deniedByUser",
	OUT_OF_TIME: "outOfTime",
	NOT_FOUND: "notFound"
};
